// Per-layer styling tokens. The colors mirror the prototype's LAYER_ACCENTS
// but expressed as Tailwind class fragments + CSS variables so they
// compose cleanly with both inline styles and utility classes.

import type { Layer, LayerGroup } from "@/lib/types";

export const LAYER_META: Record<
  Layer,
  { label: string; color: string; group: LayerGroup }
> = {
  crm:     { label: "CRM",          color: "var(--eb-50, #0176d3)", group: "data" },
  tdsx:    { label: "TDSX",         color: "var(--eb-50, #0176d3)", group: "data" },
  dc:      { label: "Data 360",     color: "var(--eb-50, #0176d3)", group: "data" },
  sdm:     { label: "C360 SDM",     color: "var(--teal, #04844b)",  group: "insight" },
  apps:    { label: "Tableau Next Apps",       color: "var(--violet, #9050e9)", group: "activation" },
  tabnext: { label: "Tableau Next Workspaces", color: "var(--violet, #9050e9)", group: "activation" },
  refresh: { label: "Refresh",      color: "var(--warn, #f5a623)",  group: "data" },
};

// NOTE: pre-mixed hex (not color-mix()) so Safari renders correctly.
// data    = #0176d3 mixed with white at 6% / 20%
// insight = #04844b mixed with white at 8% / 25%
// activation = #9050e9 mixed with white at 6% / 20%
export const LAYER_ACCENTS: Record<
  LayerGroup,
  { fg: string; bg: string; border: string; weakBg: string; weakFg: string }
> = {
  data: {
    fg: "#0176d3",
    bg: "#f0f7fc",
    border: "#cce3f6",
    weakBg: "#e6f1fa",
    weakFg: "#014486",
  },
  insight: {
    fg: "#04844b",
    bg: "#ebf5f0",
    border: "#c0e0d2",
    weakBg: "#dff0e6",
    weakFg: "#03613a",
  },
  activation: {
    fg: "#9050e9",
    bg: "#f8f5fe",
    border: "#e9dcfb",
    weakBg: "#f1eafd",
    weakFg: "#5e2db8",
  },
};
